import { Box, Paper, Typography } from '@material-ui/core';

import { ReadMore } from '@vyce/core/src/components/ReadMore';
import { FormQuestion, TextListDataPoint, Visualization } from '@vyce/core/src/types';

import { FormResultResponses } from './FormResultResponses';
import { FormResultMediaPreview } from './FormResultMediaPreview';

export const FormResultPhoto = ({
  question,
  visualization,
}: {
  question: FormQuestion;
  visualization: Visualization | undefined;
}) => {
  const points =
    visualization?.type === 'text_list'
      ? (visualization.data as TextListDataPoint[])
      : ([] as TextListDataPoint[]);

  const isAnswered = (point: TextListDataPoint): boolean => {
    const value: any = (point as any)?.value;
    if (!value) return false;
    const comment = typeof value?.comment === 'string' ? value.comment.trim() : '';
    const media = Array.isArray(value?.media) ? value.media : [];
    const hasMedia = media.some((m: any) => Boolean(m?.url));
    return Boolean(comment) || hasMedia;
  };

  const answers = points.filter(isAnswered);
  const noAnswersCount = Math.max(points.length - answers.length, 0);

  const paperStyle = {
    padding: 24,
    width: '100%',
    height: '100%',
    marginTop: 16,
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    flexDirection: 'column' as const,
  };

  return (
    <Box width="100%">
      {answers.map(answer => {
        const comment =
          typeof (answer.value as any)?.comment === 'string' ? (answer.value as any).comment : '';

        return (
          <Paper
            key={answer.index}
            variant="outlined"
            style={{
              ...paperStyle,
            }}
          >
            <Box display="flex" width="100%" paddingBottom={2} paddingTop={2}>
              <Box flex={4}>
                <Box className="form-summary-screen-only">
                  <ReadMore lines={3}>{comment.trim() || '—'}</ReadMore>
                </Box>
                <Box className="form-summary-print-only">
                  <Typography
                    variant="body2"
                    component="div"
                    style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}
                  >
                    {comment.trim() || '—'}
                  </Typography>
                </Box>
              </Box>
              <Box flex={1}>
                <Typography variant="body2" color="textSecondary">
                  {answer.participantName}
                </Typography>
              </Box>
            </Box>

            <FormResultMediaPreview media={(answer.value as any)?.media} title={question.title} />
          </Paper>
        );
      })}

      <Paper variant="outlined" style={{ ...paperStyle, alignItems: 'center', flexDirection: 'row' }}>
        <Typography variant="body1" color="textSecondary">
          No answers
        </Typography>

        <FormResultResponses count={noAnswersCount} names={[]} />
      </Paper>
    </Box>
  );
};
